var map = {
	"./100-mil-book-aus.svg": 205,
	"./100-mil-book-es.svg": 206,
	"./100-mil-book.svg": 207,
	"./3000-outlets-aus.svg": 208,
	"./3000-outlets-es.svg": 209,
	"./3000-outlets.svg": 210,
	"./50-countries-aus.svg": 211,
	"./50-countries-es.svg": 212,
	"./50-countries.svg": 213,
	"./70-mil-authors-aus.svg": 214,
	"./70-mil-authors-es.svg": 215,
	"./70-mil-authors.svg": 216,
	"./Componente 6 – 2.svg": 217,
	"./Componente 7 – 2.svg": 218,
	"./Componente 8 – 2.svg": 219,
	"./Facts-and-figures.png": 220,
	"./Google_Play.svg": 221,
	"./Logo_ESP_BRANCO.png": 222,
	"./Logo_ESP_ROXO.png": 223,
	"./X.png": 224,
	"./a4-white.svg": 225,
	"./a4.svg": 226,
	"./a5-white.svg": 227,
	"./a5.svg": 228,
	"./after-01.png": 229,
	"./after-02.png": 230,
	"./after-03.png": 231,
	"./agbook-logo-editor-load.jpg": 232,
	"./agbook-logo-mobile-2.jpg": 233,
	"./agbook-logo-mobile.png": 132,
	"./agbook-logo.png": 234,
	"./ajustes2.png": 235,
	"./alphagraphics.svg": 236,
	"./amex.svg": 237,
	"./ar_on_you.png": 238,
	"./ar_on_you.svg": 239,
	"./arquivo2.png": 240,
	"./article_shortcut.svg": 241,
	"./assistente-de-ia.png": 242,
	"./audio_file.svg": 243,
	"./audiobook-background.png": 244,
	"./authorfreely_primarylogo.png": 121,
	"./auto_stories.svg": 245,
	"./avaliacao2.png": 246,
	"./background-service-all.png": 247,
	"./background-stores.jpg": 248,
	"./banner_partner_stores.png": 249,
	"./bb.svg": 250,
	"./blogger-round-svgrepo-com.svg": 251,
	"./boleto.svg": 252,
	"./book-1-translation.png": 253,
	"./book-1.png": 254,
	"./book-2.png": 255,
	"./book-3.png": 256,
	"./book-de.png": 257,
	"./book-old.png": 258,
	"./book-type-orange.svg": 259,
	"./book-type-red.svg": 260,
	"./book-type.png": 261,
	"./book-type.svg": 262,
	"./book-upload-icon.svg": 263,
	"./book.png": 264,
	"./bookmark_heart.svg": 265,
	"./bottom-background.png": 266,
	"./bradesco.svg": 267,
	"./brand-tiktok-svgrepo-com.svg": 268,
	"./card-icon-1.svg": 269,
	"./card-icon-2.svg": 270,
	"./card-icon-3.svg": 271,
	"./card-icon-4.svg": 272,
	"./card.svg": 273,
	"./chevron-right-black.svg": 274,
	"./chevron-right.svg": 275,
	"./close.svg": 276,
	"./clube-icon-decorator.png": 277,
	"./completed-purchase-book-aus.png": 278,
	"./completed-purchase-book.png": 279,
	"./congratulations-aus.png": 280,
	"./congratulations-de.png": 281,
	"./correcoes2.png": 282,
	"./cover-revision.png": 283,
	"./creditcard.png": 284,
	"./cta-desktop-en.png": 285,
	"./cta-desktop-red.png": 286,
	"./cta-desktop.png": 287,
	"./cta-desktop_de.jpg": 288,
	"./cta-desktop_es.jpg": 289,
	"./cta-mobile-en.png": 290,
	"./cta-mobile-red.png": 291,
	"./cta-mobile.png": 292,
	"./cta-mobile_de.png": 293,
	"./cta-mobile_es.jpg": 294,
	"./dictionary.svg": 295,
	"./diners.svg": 296,
	"./divulgacao2.png": 297,
	"./edit_document.png": 298,
	"./edit_document.svg": 299,
	"./emoji_language.svg": 300,
	"./emotional-analysis_background.png": 301,
	"./epub-conversion-background.png": 302,
	"./epub3-type.png": 303,
	"./esboco.png": 304,
	"./esboco.svg": 305,
	"./facebook-share-pink.svg": 306,
	"./facebook.svg": 307,
	"./facebook2.png": 308,
	"./file-read.png": 309,
	"./first-circle.svg": 310,
	"./format_align_justify.svg": 311,
	"./format_textdirection_r_to_l.svg": 312,
	"./frete-gratis.png": 313,
	"./globe_book.svg": 314,
	"./hand-intelligent.png": 315,
	"./happy-man-using-his-tablet-home-couch_1.png": 316,
	"./happy-man-using-his-tablet-home-couch_2.png": 317,
	"./happy-man-using-his-tablet-home-couch_3.png": 318,
	"./happy-man-using-his-tablet-home-couch_4.png": 319,
	"./headphones.svg": 320,
	"./heart_plus.svg": 321,
	"./hero-background-mobile.png": 322,
	"./hero-background.png": 323,
	"./hero-book-image.png": 324,
	"./hipercard.svg": 325,
	"./icon-a4.svg": 326,
	"./icon-a5.svg": 327,
	"./icon-add.svg": 328,
	"./icon-amazon.svg": 329,
	"./icon-americanas.svg": 330,
	"./icon-apple.svg": 331,
	"./icon-arrow-down-grey.svg": 332,
	"./icon-arrow-down-purple-orange.svg": 333,
	"./icon-arrow-down-purple-white.svg": 334,
	"./icon-arrow-down-purple.svg": 335,
	"./icon-arrow-left-pagination.svg": 336,
	"./icon-arrow-right-orange.svg": 337,
	"./icon-arrow-right-pagination.svg": 338,
	"./icon-arrow-right-pink.svg": 339,
	"./icon-arrow-right-white.svg": 340,
	"./icon-book-grey.svg": 341,
	"./icon-book-orange.svg": 342,
	"./icon-book-purple.svg": 343,
	"./icon-book-white.svg": 344,
	"./icon-burger-purple.svg": 345,
	"./icon-burger-white.svg": 346,
	"./icon-camera.svg": 347,
	"./icon-cart-grey.svg": 348,
	"./icon-cart-white.svg": 349,
	"./icon-chat-orange.svg": 350,
	"./icon-chat-red.svg": 351,
	"./icon-chat.svg": 352,
	"./icon-check-green.svg": 353,
	"./icon-check-pink.svg": 354,
	"./icon-check-red.svg": 355,
	"./icon-check-white.svg": 356,
	"./icon-chevron_left-orange.svg": 357,
	"./icon-chevron_left-red.svg": 358,
	"./icon-chevron_left.svg": 359,
	"./icon-chevron_right.svg": 360,
	"./icon-close-quote.svg": 361,
	"./icon-cross-purple.svg": 362,
	"./icon-cross-red.svg": 363,
	"./icon-cross-white.svg": 364,
	"./icon-donthave.svg": 365,
	"./icon-download.svg": 366,
	"./icon-ebook-orange.svg": 367,
	"./icon-ebook.svg": 368,
	"./icon-epub.svg": 369,
	"./icon-estantevirtual.svg": 370,
	"./icon-exit-aila-editor.svg": 371,
	"./icon-export.svg": 372,
	"./icon-external.svg": 373,
	"./icon-facebook-purple.svg": 374,
	"./icon-feature-detail.svg": 375,
	"./icon-full-cover.svg": 376,
	"./icon-globe.png": 377,
	"./icon-googleplay.svg": 378,
	"./icon-has.svg": 379,
	"./icon-hasnt.svg": 380,
	"./icon-have.svg": 381,
	"./icon-header-aila-editor.svg": 382,
	"./icon-image-gallery.svg": 383,
	"./icon-image-upload.svg": 384,
	"./icon-livrariacultura.svg": 385,
	"./icon-logo-blog-white.svg": 386,
	"./icon-lp-1-orange.svg": 387,
	"./icon-lp-1-red.svg": 388,
	"./icon-lp-1.svg": 389,
	"./icon-lp-2-orange.svg": 390,
	"./icon-lp-2-red.svg": 391,
	"./icon-lp-2.svg": 392,
	"./icon-lp-3-red.svg": 393,
	"./icon-lp-3.svg": 394,
	"./icon-mercadolivre.svg": 395,
	"./icon-mini-book-orange.svg": 396,
	"./icon-mini-book.svg": 397,
	"./icon-money-orange.svg": 398,
	"./icon-money-purple.svg": 399,
	"./icon-open-chart-orange.svg": 400,
	"./icon-open-chart.svg": 401,
	"./icon-open-quote.svg": 402,
	"./icon-person-grey.svg": 403,
	"./icon-person-white.svg": 404,
	"./icon-play-two.svg": 405,
	"./icon-play.svg": 406,
	"./icon-pocket.svg": 407,
	"./icon-print-orange.svg": 408,
	"./icon-print.svg": 409,
	"./icon-profile-orange.svg": 410,
	"./icon-profile-red.svg": 411,
	"./icon-profile.svg": 412,
	"./icon-quadrado.svg": 413,
	"./icon-questionmark-orange.svg": 414,
	"./icon-questionmark-red.svg": 415,
	"./icon-questionmark.svg": 416,
	"./icon-rakuten.svg": 417,
	"./icon-search-purple-orange.svg": 418,
	"./icon-search-purple.svg": 419,
	"./icon-select-arrow.svg": 420,
	"./icon-separated-cover.svg": 421,
	"./icon-seu-livro-red.png": 422,
	"./icon-seu-livro.png": 423,
	"./icon-speak-orange.svg": 424,
	"./icon-speak-purple.svg": 425,
	"./icon-submarino.svg": 426,
	"./icon-trash-can.svg": 427,
	"./icon-trash.svg": 428,
	"./icon-tu-libro.png": 429,
	"./icon-twitter-purple.svg": 430,
	"./icon-upload-white.svg": 431,
	"./icon-upload.svg": 432,
	"./icon_linkedin.svg": 433,
	"./icons8-check.gif": 434,
	"./idioma-33.png": 435,
	"./img-footer-es.svg": 436,
	"./img-footer.svg": 437,
	"./img-footer_de.jpg": 438,
	"./img2-footer-aus.svg": 439,
	"./img2-footer-es.svg": 440,
	"./img2-footer.svg": 441,
	"./info-orange.svg": 442,
	"./info-pink.svg": 443,
	"./info-red.svg": 444,
	"./info.svg": 445,
	"./info1.jpg": 446,
	"./info2.jpg": 447,
	"./info3.jpg": 448,
	"./instagram-share-pink.svg": 449,
	"./instagram.svg": 450,
	"./instagram3.png": 451,
	"./itau.svg": 452,
	"./kloobr.png": 453,
	"./language-translate.svg": 454,
	"./laptop-cda.png": 455,
	"./library_music.svg": 456,
	"./linkedin.svg": 457,
	"./lock.svg": 458,
	"./logo-amazon-color.png": 459,
	"./logo-amazon.png": 460,
	"./logo-americanas-color.png": 461,
	"./logo-americanas.png": 462,
	"./logo-apple-color.png": 463,
	"./logo-apple.png": 464,
	"./logo-authorfreely-mobile.png": 122,
	"./logo-cda-mobile.svg": 465,
	"./logo-cda.svg": 466,
	"./logo-club-de-autores.png": 467,
	"./logo-clube-de-autores-share.png": 468,
	"./logo-clube-de-autores-share.svg": 469,
	"./logo-clube-de-autores.svg": 470,
	"./logo-cultura-color.png": 471,
	"./logo-cultura.png": 472,
	"./logo-estante-color.png": 473,
	"./logo-estante.png": 474,
	"./logo-google-color.png": 475,
	"./logo-google.png": 476,
	"./logo-literary-highways.png": 477,
	"./logo-mercado-color.png": 478,
	"./logo-mercado.png": 479,
	"./logo-rakuten-color.png": 480,
	"./logo-rakuten.png": 481,
	"./logo-submarino-color.png": 482,
	"./logo-submarino.png": 483,
	"./lp-banner-a-desktop.png": 484,
	"./lp-banner-a-mobile.png": 485,
	"./lp-banner-b-desktop-red.png": 486,
	"./lp-banner-b-desktop.png": 487,
	"./lp-banner-b-mobile-red.png": 488,
	"./lp-banner-b-mobile.png": 489,
	"./mastercard.svg": 490,
	"./medium-shot-excited-woman-with-laptop-2.png": 491,
	"./medium-shot-excited-woman-with-laptop-mini-1.png": 492,
	"./medium-shot-excited-woman-with-laptop-mini-2.png": 493,
	"./medium-shot-excited-woman-with-laptop-mini-3.png": 494,
	"./medium-shot-excited-woman-with-laptop.png": 495,
	"./metadata.png": 496,
	"./mood_heart.svg": 497,
	"./new-icon-facebook.svg": 498,
	"./new-icon-linkedin.svg": 499,
	"./new-icon-twitter.svg": 500,
	"./norton.svg": 501,
	"./nota-final2.png": 502,
	"./pdf.png": 503,
	"./pix.png": 504,
	"./play_circle.svg": 505,
	"./pocket-white.svg": 506,
	"./pocket.svg": 507,
	"./preco2.png": 508,
	"./privacidade2.png": 509,
	"./psychology.svg": 510,
	"./publico2.png": 511,
	"./publish-book.png": 512,
	"./publish-book_agbook-2.png": 513,
	"./publish-book_agbook.png": 514,
	"./publish-book_en.png": 515,
	"./publish-book_es.png": 516,
	"./quadrado-white.svg": 517,
	"./quadrado.svg": 518,
	"./record_voice_over.svg": 519,
	"./relatorio2.png": 520,
	"./responsabilidade.png": 521,
	"./room-circle.svg": 522,
	"./second-circle.svg": 523,
	"./sentiment_stressed.svg": 524,
	"./services-footer-1.png": 525,
	"./services-footer-2.png": 526,
	"./services-footer-3.png": 527,
	"./services-footer-4.png": 528,
	"./services-footer-5.png": 529,
	"./slider-arrow-left-grey.svg": 530,
	"./slider-arrow-right-grey.svg": 531,
	"./spellcheck.svg": 532,
	"./stars_1-orange.svg": 533,
	"./stars_1-red.svg": 534,
	"./stars_1.svg": 535,
	"./stars_2-orange.svg": 536,
	"./stars_2-red.svg": 537,
	"./stars_2.svg": 538,
	"./stars_3-orange.svg": 539,
	"./stars_3-red.svg": 540,
	"./stars_3.svg": 541,
	"./stars_4-orange.svg": 542,
	"./stars_4-red.svg": 543,
	"./stars_4.svg": 544,
	"./stars_5-orange.svg": 545,
	"./stars_5-red.svg": 546,
	"./stars_5.svg": 547,
	"./stars_sprint.png": 548,
	"./stars_sprint.svg": 549,
	"./stars_sprint_orange.svg": 550,
	"./stars_sprint_red.svg": 551,
	"./third-circle.svg": 552,
	"./thumb-mini_de.jpg": 553,
	"./twitter-share-pink.svg": 554,
	"./twitter.svg": 555,
	"./user-account-en.png": 556,
	"./user-book.png": 557,
	"./visa.svg": 558,
	"./whatsapp.svg": 559,
	"./word-file-icon.svg": 560,
	"./word-message-aus.svg": 561,
	"./word-message-es.svg": 562,
	"./word-message.svg": 563,
	"./wordpress.svg": 564,
	"./your-book-mini-aus.png": 565,
	"./youtube-play-svgrepo-com.svg": 566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;